(function () {
    let $body = $('body');

    const dropblockUl = {
        $target: null,
        $toggle: null,
        $ul: null,
        $li: null,
        isMobile: parseInt(UX.grid?.screenSm && UX.grid.screenSm - 0.2) >= window.innerWidth,
        vPort: 'screen-sm', // default responsive break point

        classes: {
            iconChevronDown: 'icon-arrow_d_n pull-right',
        },

        init: function () {
            dropblockUl.$target = $('.profile-menu');
            dropblockUl.on.build();
            dropblockUl.control();
        },
        control: function () {
            $body.on('click', '.profile-menu--res a', function (e) {
                dropblockUl.on.select.dropdown($(this));
            });

            $(document).on(dropblockUl.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                if (!dropblockUl.isMobile) {
                    dropblockUl.isMobile = true;
                    dropblockUl.on.build();
                }
            });

            $(document).on(dropblockUl.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                if (dropblockUl.isMobile) {
                    dropblockUl.isMobile = false;
                    dropblockUl.on.build();
                }
            });
        },
        on: {
            select: {
                dropdown: function (elem) {
                    const dataAttr = elem.closest('ul').data('mobile-toggle');
                    if (dataAttr === 'dropdown' || elem.closest('ul').hasClass('dropblock--tab')) {
                        const dropdownContainer = elem.closest('.dropBlock');
                        dropdownContainer.children('a').find('span').text(elem.text());
                    }
                },
            },
            dropdownBuild: function (elem) {
                // rebuild tabs to be as drop down
                if (UX.dropBlock) {
                    UX.dropBlock.init();
                }

                elem.wrap('<div class="profile-menu--dropBlock" data-db-parent-of="dbTab-profile-menu"></div>');

                const $dropdownContainer = elem.closest('.profile-menu--dropBlock');
                const $activeTab = dropblockUl.get.activeTab(elem);

                $dropdownContainer.prepend(
                    '<a href="#" data-db-target-for="dbTab-profile-menu"><span>' +
                        $activeTab.text() +
                        '</span><i class="' +
                        dropblockUl.classes.iconChevronDown +
                        '" aria-hidden="true"></i></a>'
                );
                elem.attr('data-db-target-of', 'dbTab-profile-menu');
            },
            dropdownDestroy: function (elem) {
                // return tabs to default

                var dropdownContainer = elem.closest('.profile-menu--dropBlock');
                dropdownContainer.children('a').remove();
                elem.removeAttr('data-db-target-of')
                    .removeClass('js--open')
                    .removeAttr('style')
                    .unwrap('.profile-menu--dropBlock');
            },
            build: function () {
                if (dropblockUl.isMobile) {
                    $('.profile-menu').addClass('profile-menu--res'); // class will be used in our scss (to replace media queries)
                    dropblockUl.on.dropdownBuild(dropblockUl.$target);
                } else {
                    $('.profile-menu').removeClass('profile-menu--res');
                    dropblockUl.on.dropdownDestroy(dropblockUl.$target);
                }
            },
        },
        get: {
            activeTab: function (elem) {
                return elem.find('a.active,.active a');
            },
        },
    };
    UX.dropblockUl = dropblockUl; // add to global namespace
})();
